import {
    LOAD_BIDIB,
    UPDATE_BIDIB,
    LOAD_PLAN,
    UPDATE_PLAN,
    SET_EDITMODE,
    SET_LCCONTAINER,
    SIGNAL_CLICK,
    LC_SELECT,
    ITEM_SELECT, GUI_STATE, NODE_SELECT, selectNode
} from "./actions";

import {createReducer} from "@reduxjs/toolkit";
import {mergeDeep} from "./merger";
import {send_route_cmd} from "../components/etc/cmd";

const bidibInitialState = {
    data: {
        node: [],
        //connection: [],
        record: [],
        client: [],
    }
}

export const bidibReducer = createReducer(bidibInitialState, (builder) => {
    builder
        .addCase(LOAD_BIDIB, (state, action) => {
            state.data = action.data

            if( state.root && !state.root.selected_node) {
                selectNode(state.data.node.find(it => it.path === "0.0.0.0"))
            }

        })
        .addCase(UPDATE_BIDIB, (state, action) => {

            if( state.data['record'] && Array.isArray(action.data['record'])) {
                state.data['record'] = action.data['record']
            } else if( state.data.node && Array.isArray(action.data.node)) {
                state.data.node = action.data.node

            //} else if( state.data['client'] && Array.isArray(action.data['client'])) {
            //    state.data['client'] = action.data['client']
            } else {
                if( state.data[action.data.type]) {

                    const idx = state.data[action.data.type].findIndex(it =>
                        it.uid === action.data.uid && it.type === action.data.type
                    )
                    if (~idx) {
                        mergeDeep(state.data[action.data.type][idx], action.data)
                    } else {
                        state.data[action.data.type].push(action.data)
                    }

                }
            }
        })
})

const planInitialState = {
    items: [],
}

export const planReducer = createReducer(planInitialState, (builder) => {
    builder
        .addCase(LOAD_PLAN, (state, action) => {
            state.items = action.data
        })
        .addCase(UPDATE_PLAN, (state, action) => {
            const idx = state.items ? state.items.findIndex(it =>
                it.id === action.data.id
            ) : -1
            if (~idx) {
                //console.log("action.data")
                //console.log(action.data)
                //action.data.id = toString(action.data.id)

                mergeDeep(state.items[idx], action.data)
            } else {
                state.items.push(action.data)
            }
        })
})

const rootInitialState = {
    lccontainer: true,
    editmode: false,
    selected_lc: "",
    selected_item: null,
    selected_node: null,
    //innerHeight: window.innerHeight - 150,
    gui_state: localStorage.getItem('gui_state') != null ? JSON.parse(localStorage.getItem('gui_state') ): [],
}

export const rootReducer = createReducer(rootInitialState, (builder) => {
    builder
        .addCase(SET_EDITMODE, (state, action) => {
            state.editmode = action.data
        })
        .addCase(SET_LCCONTAINER, (state, action) => {
            state.lccontainer = action.data
        })
        .addCase(LC_SELECT, (state, action) => {
            state.selected_lc = action.data
        })
        .addCase(ITEM_SELECT, (state, action) => {
            state.selected_item = action.data
        })
        .addCase(NODE_SELECT, (state, action) => {
            state.selected_node = action.data
        })
        .addCase(GUI_STATE, (state, action) => {

            const idx = state.gui_state ? state.gui_state.findIndex(it =>
                it.id === action.data.id
            ) : -1
            if (~idx) {
                //console.log("action.data")
                //console.log(action.data)
                //action.data.id = toString(action.data.id)

                mergeDeep(state.gui_state[idx], action.data)
            } else {
                state.gui_state.push(action.data)
            }

            localStorage.setItem('gui_state', JSON.stringify(state.gui_state));
        })
        .addCase(SIGNAL_CLICK, (state, action) => {
            var sss = true;
            var sis = "-";
            var lastdir = '-';


            if( state.startsignalset) {
                sss = false;

                var cc = {
                    id: "["+state.startsignal+"]-["+action.sg.sg.id+"]",
                    from: state.startsignal,
                    to: action.sg.sg.id,
                    from_dir: state.lastsignaldir,
                    to_dir: action.sg.sg.cl,
                };

                if( action.sg.sg.bauf ) {
                    cc.action = action.sg.sg.bauf
                }

                send_route_cmd(cc);
            } else {
                sss = true
                sis = action.sg.sg.id
                lastdir = action.sg.sg.cl
            }

            state.startsignalset = sss
            state.startsignal = sis
            state.lastsignaldir = lastdir
        })
})
